import * as types from 'modules/selfServices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export const initialState = false;

const open = () => true;

const reset = () => initialState;

export default createReducer(initialState, {
  [types.OPEN_SEND_WIZARD]: open,
  [types.SEND_SELF_SERVICE_SUCCESS]: reset,
  [types.CLOSE_SEND_WIZARD]: reset,
});
